import classNames from 'classnames';
import { Heading } from 'yoso';
import { useChallengeRewardCriteria } from '~/components/Challenge/Boost/ChallengeBoost.hooks';
import { useChallengeExpect } from '~/components/Challenge/Challenge.hooks';
import summaryStyles from '~/components/Challenge/Summary/ChallengeSummary.module.scss';
import { T } from '~/components/I18n';
import { QuestionV2 } from '~/components/Icon/QuestionV2';
import { useMember } from '~/components/Member/Member.hooks';
import { Tooltip } from '~/components/Tooltip/Tooltip';
import { formatKaia } from '~/components/Util/number';
import styles from './ChallengeEventSummary.module.scss';
export type ChallengeEventSummaryProps = {
  className?: string;
};

export const ChallengeEventSummary = ({ className }: ChallengeEventSummaryProps) => {
  const {
    data: { region = 'GL' },
  } = useMember();
  const {
    data: { week, rewardAmount, rewardCurrency, maxReward, maxRewardCurrency },
    isInitialLoading,
  } = useChallengeExpect();
  const {
    data: { maxPurchaseRewardRate },
  } = useChallengeRewardCriteria();

  return (
    <div className={classNames(summaryStyles.root, className)}>
      <Heading level={4} className={summaryStyles.heading}>
        <T name="citizen_challenge_history_reward_title" options={[week]} />
        <span className={classNames(summaryStyles.highlight, styles.reward)}>
          {' '}
          {formatKaia(rewardAmount, { zeroAsEmpty: isInitialLoading })} {rewardCurrency}
        </span>
      </Heading>
      <div className={summaryStyles.description}>
        <span>
          <T name="citizen_challenge_history_reward_desc" />{' '}
          {formatKaia(maxReward, { zeroAsEmpty: isInitialLoading })} {maxRewardCurrency}
        </span>
        <Tooltip
          className={summaryStyles.tooltip}
          variant="secondary"
          direction="bottom"
          tooltipText={
            <T
              name={
                region === 'JP'
                  ? 'citizen_challenge_history_reward_tooltip_jp'
                  : 'citizen_challenge_history_reward_tooltip'
              }
              options={[maxPurchaseRewardRate]}
            />
          }>
          <QuestionV2 className={summaryStyles.icon} />
        </Tooltip>
      </div>
    </div>
  );
};
